import { Box } from "@mui/material";
import { star, StarFeaturedSelected } from "@platformx/shared/static-assets";
import { XToolTip } from "../XToolTip/XToolTip";
import { useStyles } from "./MarkFeatured.styles";
import ToolTipMessage from "./ToolTipMessage";

export default function MarkFeatured({ setIsFeatured, isFeatured }: any) {
  const classes = useStyles();
  return (
    <Box sx={{ padding: "0px 4px" }} onClick={() => setIsFeatured((prev) => !prev)}>
      {isFeatured ? (
        <Box className={classes.BoxImage} data-testid='featured'>
          <img src={StarFeaturedSelected} alt='featured' width={22} height={22} />
        </Box>
      ) : (
        <XToolTip
          component={
            <Box className={classes.BoxImage} data-testid='featured'>
              <img src={star} alt='markfeature' width={22} height={22} />
            </Box>
          }
          Title={<ToolTipMessage />}
          position='bottom'
        />
      )}
    </Box>
  );
}
